import { HttpClient } from "@angular/common/http";
import { LacrosseEntity } from "./lacrosse.entity";
import { FirebaseAuthService } from "../noizu/services/firebase-auth.service";

export class SynchQueueEntryEntity extends LacrosseEntity {
  public _kind = "synch-queue-entry";
  public environment;
  public entityClass;
  public entityIdentifier;
  public status;
  public requestToken;

  constructor(client: HttpClient, auth: FirebaseAuthService, json) {
    super(client, auth, json);
    this.environment = json["environment"];
    this.entityClass = json["entityClass"];
    this.entityIdentifier = json["entityIdentifier"];
    this.status = json["status"];
    this.requestToken = json["requestToken"];
  }

  public retry(purge) {
    const ps = purge === true ? "true" : "false";
    return this._put(
      `${this.apiBase()}/backend-synch-queue/${
        this.identifier
      }/synchronize?purge=${ps}`,
      {},
      (data, resolve) => {
        console.log(data);
        resolve(data);
      },
      {}
    );
  }
}
